<template>
    <generic-page>
        <div class="text-center py-4">
            <h5>{{ $t("Rate this call") }}</h5>
            <div class="text-secondary small mb-3">
                {{ $t("Your rating helps us improve matches") }}
            </div>

            <div class="d-flex justify-content-center mb-3">
                <b-btn
                    :key="star"
                    v-for="star in 5"
                    @click="submit(star)"
                    variant="link"
                    class="text-warning"
                    style="font-size: 32px"
                >
                    <font-awesome-icon icon="fa-duotone fa-star" />
                </b-btn>
            </div>

            <b-btn @click="skip" variant="link" pill block>
                {{ $t("Skip rating") }}
            </b-btn>
        </div>
    </generic-page>
</template>

<script>
export default {
    methods: {
        submit(rating) {
            this.$store.dispatch("randomCall/submitRating", rating);
        },
        skip() {
            this.$store.dispatch("randomCall/skipRating");
        },
    },
};
</script>
